import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "./../../components/card/card.jsx";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { toast } from "react-toastify";
import {
  machineProfile,
  asset,
  workOrder,
  inventory,
} from "../../api/index.js";
import { QRCode } from "react-qrcode-logo";
import LoadingIndicator from "../../components/LoadingIndicator/index.jsx";
import {
  renderImage,
  printLocation,
  Loader,
  formatDateOnly,
  getStatusColor,
  formatDateFull,
} from "../../utils/helper.jsx";
import { format } from "date-fns";
import ImageViewer from "../../components/ImageViewer";
import DataTable from "react-data-table-component";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";

const printDate = (date) => {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    // it is a date
    if (isNaN(date)) {
      // d.getTime() or d.valueOf() will also work
      return "-";
    } else {
      // date object is valid
    }
  } else {
    return "-";
  }
  if (!date) return "-";
  const dateSplit = date.split("-");
  const day = dateSplit[0] ? dateSplit[0] : "";
  const month = dateSplit[1]
    ? format(new Date().setMonth(dateSplit[1] - 1), "MMMM")
    : "";
  const year = dateSplit[2] ? dateSplit[2] : "";
  return day + " " + month + " " + year;
};

function PageAssetProfile({ assetId }) {
  let { id } = useParams();
  if (!id) id = assetId;
  const { hash } = useLocation();
  const { config, isHiddenFeature, getLocationName } = useAuth();
  const [attachments, setAttachments] = useState([]);
  const roleItem = config?.RoleCompanyMaster[0]?.feature_access;
  const woExist = roleItem?.find((item) => item === "Work Order Overview");
  const [openModal, setOpenModal] = React.useState(false);
  const defaultMenu = hash
    ? hash.replace("#", "")
    : !isHiddenFeature("machine_health")
    ? "machinehealth"
    : "sensor";
  const [selectedAsset, setSelectedAsset] = useState();
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState();
  const location = useLocation();
  const [documents, setDocuments] = useState([]);
  const [docName, setDocName] = useState(null);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [subNavMenus, setSubNavMenus] = useState([]);
  const [activeMenu, setActiveMenu] = useState(defaultMenu);
  const [loading, setLoading] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);

  const [locations, setLocations] = useState([]);
  const getAsset = async () => {
    try {
      setLoading(true);
      const res = await asset.getOne(id);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setSelectedAsset(data);
        const att = [];
        if (data.attachments) {
          Object.keys(data.attachments).forEach((key) => {
            if (data.attachments[key]) {
              const name = key.split("_")[3];
              const type = key.split("_")[2];
              const isRequest = key.split("_")[0] !== "workoder";
              const url = renderImage(
                `machine/attachment/${data.attachments[key]}`
              );
              const attachment = {
                name: name,
                type,
                url,
                value: data.attachments[key],
              };
              att.push(attachment);
              // if (!isRequest) {
              //
              // }else{
              //   attReq.push(attachment)
              // }
            }
          });
          setAttachments(att);
        }
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  async function deleteWo() {
    try {
      const response = await workOrder.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This work order has been deleted");

          setDeleteRow(null);
          await getAsset();
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  useEffect(() => {
    //console.log("fetching wave");
    getAsset();
  }, [id]);

  useEffect(() => {
    if (selectedAsset) {
      const locationName = [];
      function generateLocation(location) {
        locationName.push(location.location_name);
        if (location.parent_location) {
          generateLocation(location.parent_location);
        }
      }

      generateLocation(selectedAsset.location);
      setLocations(locationName.reverse());
    }
  }, [selectedAsset]);
  function isActive(item) {
    return item === activeMenu;
  }

  useEffect(() => {
    if (!selectedFile) {
      setPicture(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPicture(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">More detail</div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Asset</label>
                      <p>{data.asset?.asset_name}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Category</label>
                      <p>{data.category?.name}</p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Priority</label>
                      <p>{data.priority}</p>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted By</label>
                      <p>{data.created_by_user?.firstname}</p>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Submitted At</label>
                      <p>
                        {format(new Date(data.created_at), "yyyy-MM-dd hh:mm")}
                      </p>
                    </div>
                  </div>
                </div>
                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => navigate("/work-order/detail/" + data.id)}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Detail
                </button>

                <button
                  onClick={() => navigate("/work-order/edit/" + data.id)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-warning"
                >
                  <i className="fa fa-edit"></i> Edit Work Order
                </button>

                <button
                  onClick={() => showConfirmationDlg(data)}
                  type="button"
                  style={{ marginRight: "10px" }}
                  className="btn btn-outline-danger"
                >
                  <i className="fa fa-edit"></i> Delete Work Order
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  let columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      minWidth: "150px",
    },

    {
      name: "Category",
      selector: (row) => row.category?.name,
    },

    {
      name: "Priority",
      selector: (row) => row.priority,
      cell: (row) => (
        <span
          className={`badge border ${
            row.priority === "high"
              ? "border-danger text-danger"
              : row.priority === "medium"
              ? "border-warning text-warning"
              : "border-success text-success"
          }`}
          style={{ textTransform: "capitalize" }}
        >
          {row.priority}
        </span>
      ),
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <span
          className={`badge border border-${getStatusColor(
            row.status
          )} text-${getStatusColor(row.status)}`}
        >
          {row.status}
        </span>
      ),
    },
    {
      name: "Start Date",
      selector: (row) => row.start_date,
      cell: (row) => formatDateOnly(row.start_date),
    },
    {
      name: "Due Date",
      selector: (row) => row.due_date,
      cell: (row) => formatDateOnly(row.due_date),
    },
    {
      name: "Submitted By",
      selector: (row) => row.created_by_user?.firstname,
    },
    {
      name: "Submitted At",
      selector: (row) => row.created_at,
      cell: (row) => formatDateOnly(row.created_at),
    },
  ];

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  return (
    <div>
      <LoadingIndicator open={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">ASSET</li>
            <li className="breadcrumb-item active">ASSET DETAIL</li>
          </ol>
          <h1 className="page-header mb-0">Asset Detail</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-4">
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset Information
            </CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-lg-12 col-sm-12 mb-2">
                  <Card>
                    <CardBody style={{ padding: "7px" }}>
                      <ImageViewer src={selectedAsset?.asset_image} />
                    </CardBody>
                    <CardFooter className="text-theme fw-bold text-center">
                      {selectedAsset?.asset_name}
                    </CardFooter>
                  </Card>
                </div>
                <div className="col-lg-12 col-sm-12">
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Asset Type</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.asset_type}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Asset Category</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.asset_category}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Serial Number</div>
                      <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                        {selectedAsset?.serial_number}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Description</div>
                      <span
                        style={{ textAlign: "right" }}
                        className="texh-right text-theme fw-bold fs-12px ms-auto me-2"
                      >
                        {selectedAsset?.description}
                      </span>
                    </div>
                  </div>
                  <hr style={{ margin: "0.3rem 0" }} />
                  <div className="d-flex">
                    <div className="flex-1 d-flex">
                      <div>Ownership</div>
                      <span
                        style={{ textAlign: "right" }}
                        className="texh-right text-theme fw-bold fs-12px ms-auto me-2"
                      >
                        {selectedAsset?.customer_id &&
                          selectedAsset.customer.customer_name}
                        {selectedAsset?.user_id &&
                          selectedAsset.user.firstname +
                            " " +
                            selectedAsset.user.lastname}
                        {selectedAsset?.team_id && selectedAsset.team.team_name}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset Location
            </CardHeader>
            <CardBody className="card-body pb-2">
              {locations.map((l, index) => {
                return (
                  <div key={index}>
                    <div className="d-flex">
                      <div className="flex-1 d-flex">
                        <div> {getLocationName(index)}</div>
                        <span className=" text-theme fw-bold fs-12px ms-auto me-2">
                          {printLocation(l)}
                        </span>
                      </div>
                    </div>
                    <hr style={{ margin: "0.3rem 0" }} />
                  </div>
                );
              })}
            </CardBody>
          </Card>
          <Card className="mb-4">
            <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
              Asset QR Code
            </CardHeader>
            <CardBody className="card-body pb-2 text-center">
              <QRCode
                value={selectedAsset?.barcode}
                logoImage={"/cmms/logo.png"}
              />
            </CardBody>
          </Card>
          {attachments.length > 0 && (
            <div className="mb-3">
              <Card>
                <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
                  Attachments
                </CardHeader>
                <CardBody>
                  <div class="row">
                    {attachments.map((attachment, index) => (
                      <div key={index} className={"col-md-6 position-relative"}>
                        {attachment.type === "image" && (
                          <ImageViewer
                            staticImage={attachment.url}
                            className={"img-fluid w-100"}
                            alt=""
                          />
                        )}
                        {attachment.type === "video" && (
                          <video
                            src={attachment.url}
                            className={"img-fluid w-100"}
                            width={"100%"}
                            controls
                          />
                        )}
                        {attachment.type === "pdf" && (
                          <iframe
                            src={attachment.url}
                            className={" w-100"}
                            width={"100%"}
                            height={"350px"}
                          />
                        )}
                        {attachment.type === "other" && (
                          <a
                            href={attachment.url}
                            target={"_blank"}
                            rel="noreferrer"
                            style={{
                              height: "200px",
                              paddingTop: "95px",
                              display: "block",
                            }}
                            className={
                              "border-theme border-1 border w-100 text-center"
                            }
                          >
                            Download the File
                          </a>
                        )}

                        <div className="my-2">
                          <input
                            type="text"
                            className={"form-control"}
                            value={attachment.name}
                            readOnly
                            disabled
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </div>
          )}
        </div>
        <div className="col-lg-8">
          <Card className="mb-4">
            <CardBody>
              <ul className="nav nav-tabs">
                <li className="nav-item me-1">
                  <a
                    href="#home"
                    className="nav-link active"
                    data-bs-toggle="tab"
                  >
                    Work Order
                  </a>
                </li>
                <li className="nav-item me-1">
                  <a
                    href="#parts"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Parts Histories
                  </a>
                </li>
                <li className="nav-item me-1">
                  <a
                    href="#movement"
                    className={`nav-link ${
                      isHiddenFeature("machine_health") ? "active" : ""
                    }`}
                    data-bs-toggle="tab"
                  >
                    Movement Histories
                  </a>
                </li>
                {/* <li className="nav-item me-1">
                  <a href="#success" className="nav-link" data-bs-toggle="tab">
                    Meter
                  </a>
                </li> */}
                {/*<li className="nav-item me-1">*/}
                {/*  <a href="#wo" className="nav-link" data-bs-toggle="tab">*/}
                {/*    Work Order Schedule*/}
                {/*  </a>*/}
                {/*</li>*/}
              </ul>
              <div className="tab-content pt-3">
                <div className="tab-pane fade show active" id="home">
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                      onClick={() => navigate("/work-order/add")}
                      className="btn btn-outline-theme"
                    >
                      Create Work Order
                    </button>
                  </div>
                  <hr />

                  <Card>
                    <CardBody>
                      <DataTable
                        highlightOnHover
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={selectedAsset?.work_orders || []}
                        pagination
                      />
                    </CardBody>
                  </Card>
                </div>
                <div className="tab-pane fade" id="parts">
                  {selectedAsset?.work_orders.map((wo, indexWo) => {
                    return (
                      <Card style={{ marginBottom: "20px" }} key={indexWo}>
                        <CardHeader>{wo.title}</CardHeader>
                        <CardBody>
                          {wo.inventories.map((inventory, indexInventory) => {
                            return (
                              <div key={indexInventory}>
                                {inventory.inventory.part.part_name} :{" "}
                                {inventory.quantity}
                              </div>
                            );
                          })}
                          {wo.inventories.length == 0 &&
                            "- There is no part used -"}
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>

                <div className="tab-pane fade" id="movement">
                  {selectedAsset?.changeLogs.map((log, indexWo) => {
                    return (
                      <Card style={{ marginBottom: "20px" }} key={indexWo}>
                        <CardHeader style={{ textTransform: "capitalize" }}>
                          {log.type} Change
                        </CardHeader>
                        <CardBody>
                          <b>
                            {log.old_value}{" "}
                            <span className="fa fa-arrow-right"></span>{" "}
                            {log.new_value}
                          </b>{" "}
                          at <i>{formatDateFull(log.created_at)}</i>
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
              </div>
            </CardBody>
          </Card>

          {deleteRow && (
            <ConfirmationDlg
              title={"Delete Work Order"}
              open={!!deleteRow}
              onClose={hideConfirmationDialog}
              onSubmit={deleteWo}
            >
              <p style={{ pb: 2 }}>
                Are you sure you want to delete this work order{" "}
                <strong>{deleteRow.title}</strong> ?
              </p>
            </ConfirmationDlg>
          )}
        </div>
      </div>
    </div>
  );
}

export default PageAssetProfile;
